module.exports = __webpack_public_path__ + "static/img/repast04.c78efdc0.jpg";